import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import LoadingComp from "../components/re-usable/loading/loading";
import Router from "../routes/convergence-2024-routes";
import Footer from "../components/footer/footer";

const ConvergenceLayout = () => {
  return (
    <>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {Router.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

export default ConvergenceLayout;